import { create } from "zustand";
import { tempEngagement, tempLeadEng } from "../api_layer/api";
import { todayEngagement } from "../api_layer/api";
import moment from "moment";
import { RECEPTIONINST } from "modules/utilities/utility_2";

const useActionableListStore = create((set) => ({
  tempEngData: [],
  todayEngData: [],
  tempLeadData:[],
  tempLoading: false,
  todayLoading: false,
  tempLeadLoading:false,
  error: null,
  fetchTodayEngData: async (tag = null) => {
    try {
      const today = moment();
      const fifteenDaysAgo = today.clone().subtract(15, "days");

      set({ todayLoading: true, error: null });
      const response = await todayEngagement(
        fifteenDaysAgo.format("YYYY-MM-DD"),
        RECEPTIONINST ? today.clone().add(7, 'days').format("YYYY-MM-DD") : today.format("YYYY-MM-DD"),
        tag
      );
      set({ todayEngData: response.data, todayLoading: false });
    } catch (error) {
      set({ error: error.message, todayLoading: false });
    }
  },
  fetchTempEngData: async (tag = null) => {
    try {
      set({ tempLoading: true, error: null });
      const response = await tempEngagement(tag);
      set({ tempEngData: response.data, tempLoading: false });
    } catch (error) {
      set({ error: error.message, tempLoading: false });
    }
  },
  fetchLeadTempData: async () => {
    try {
      const today = moment();
      const fifteenDaysAgo = today.clone().subtract(15, "days");

      set({ tempLeadLoading: true, error: null });
      const response = await tempLeadEng(
        fifteenDaysAgo.format("YYYY-MM-DD"),
        today.format("YYYY-MM-DD")
      );
      set({ tempLeadData: response.data, tempLeadLoading: false });
    } catch (error) {
      set({ error: error.message, tempLeadLoading: false });
    }
  },
}));

export default useActionableListStore;
// tempLeadEng
